import torreWork from '@/components/torrework/TorreWork'

export default [
  {
    path: '/torrework',
    name: 'torrework',
    component: torreWork,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/torreWorkRoutes.js